import { render, staticRenderFns } from "./ActivityCalendar.vue?vue&type=template&id=56a321b8"
import script from "./ActivityCalendar.vue?vue&type=script&lang=js"
export * from "./ActivityCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports